/** "vip, payments" → ['vip', 'payments'] — trimmed, deduped, capped at the API's limit of 12. */
export const parseTags = (raw: string): string[] =>
  [...new Set(raw.split(',').map((t) => t.trim()).filter(Boolean))].slice(0, 12);
